import { domainScopeForLineage } from "@/lib/lineage/domainScopeForLineage";
import {
  useDomainEventStore,
  type DomainCreatedEntity,
  type DomainEvent,
} from "@/stores/useDomainEventStore";
import type { SourceType } from "@/services/lineageEdgeService";

export type LineageUpdateAction = "attached" | "detached";

export interface PublishLineageUpdatedInput {
  action: LineageUpdateAction;
  edgeId: string;
  subjectType: SourceType;
  subjectPublicId: string;
  targetType: string;
  targetPublicId: string;
  projectId: string;
  source?: string;
  createdEntities?: DomainCreatedEntity[];
  toolName?: string;
  toolCallId?: string;
}

/**
 * Publishes `lineage.updated` on the client domain bus for lineage graph mutations.
 */
export function publishLineageUpdated(input: PublishLineageUpdatedInput): DomainEvent {
  const scope = domainScopeForLineage(
    input.projectId,
    input.targetType,
    input.targetPublicId,
  );

  return useDomainEventStore.getState().publishDomainEvent({
    eventType: "lineage.updated",
    scope,
    entityTypesAffected: [input.subjectType, "lineage"],
    source: input.source ?? "lineage_edge_service",
    payload: {
      action: input.action,
      edgeId: input.edgeId,
      subjectType: input.subjectType,
      subjectPublicId: input.subjectPublicId,
      targetType: input.targetType,
      targetPublicId: input.targetPublicId,
      createdEntities: input.createdEntities,
      toolName: input.toolName,
      toolCallId: input.toolCallId,
    },
  });
}
